// Generated by scripts/build-ui-icons.mjs.
export { Pause as default } from "../ui/glyphs-5";
